import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "provider";

export const providerService = {
    getLogo
};

function getLogo(providerId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getLogo/?providerId=${providerId}`, requestOptions).then(handleResponse);
}
